/*
 *  FAQ Template
 *    Scripts for the faq template section
 *  Version:
 *    1.0.0 - 2022/03/09
 */
import { initAccordion } from '../objects/accordion/accordion';
import {
  CLASS_ACTIVE,
  CLASS_VISIBLE,
  CLASS_INITIALISED,
} from '../tools/constants/classes';

// Attributes
const ATTR_CATEGORY_HANDLE = 'data-category-handle';
const ATTR_ACCORDION_CATEGORY = 'data-accordion-category';

// Selectors
const SELECTOR_FAQ_SECTION = '[data-faq]';
const SELECTOR_FAQ_BUTTON = '[data-faq-category-button]';
const SELECTOR_CONTAINER = '[data-accordion-container]';
const SELECTOR_ACCORDION = '[data-accordion]';
const SELECTOR_SELECT = '[data-category-select]';
const SELECTOR_OPTION = '[data-category-select-option]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_FAQ_SECTION)
  .forEach((section) => {
    const categoryButtons =
      section?.querySelectorAll<HTMLElement>(SELECTOR_FAQ_BUTTON);
    const accordions = section?.querySelector<HTMLElement>(SELECTOR_CONTAINER);
    const accordion =
      section?.querySelectorAll<HTMLElement>(SELECTOR_ACCORDION);
    const select = section?.querySelector<HTMLInputElement>(SELECTOR_SELECT);
    const selectOptions =
      section?.querySelectorAll<HTMLOptionElement>(SELECTOR_OPTION);
    // Set Source of Truth - category
    let selectedCategory: string;

    if (!accordions) return;
    initAccordion({ container: accordions });

    // Setup buttons or desktop nav tabs
    categoryButtons?.forEach((button) => {
      button.addEventListener('click', (evt) => {
        const category = button?.getAttribute(ATTR_CATEGORY_HANDLE);
        // scroll top
        const topElement = document.querySelector('.c-faq__accordions');
        window.scrollTo({
          behavior: 'smooth',
          top: 400,
          left: 0,
        });
        topElement?.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });

        if (!category) return;
        switchCategory(category);
        // set the category to the clicked button
        selectedCategory = category;
        showSelectedAccordion(selectedCategory);
        // sync with mobile
        selectDropdown();
      });
    });

    /**
     * Sets the active category across buttons and accordions
     * @param activeCategory String used as the active category to switch to
     */

    // show accordion based on selectedCategory
    const showSelectedAccordion = (activeCategory: string) => {
      accordion?.forEach((accordion) => {
        const accordionCategory = accordion.getAttribute(
          ATTR_ACCORDION_CATEGORY
        );
        // update class
        if (accordionCategory === activeCategory) {
          accordion.classList.add(CLASS_VISIBLE);
        } else {
          accordion.classList.remove(CLASS_VISIBLE);
        }
      });
    };

    const switchCategory = (activeCategory: string) => {
      // Update buttons class
      categoryButtons?.forEach((button) => {
        const buttonCategory = button.getAttribute(ATTR_CATEGORY_HANDLE);

        if (buttonCategory === activeCategory) {
          button.classList.add(CLASS_ACTIVE);
        } else {
          button.classList.remove(CLASS_ACTIVE);
        }
      });
    };

    // Select Dropdown - sync with desktop nav tabs
    const selectDropdown = () => {
      const optionSelected = selectOptions[0];
      optionSelected.setAttribute('selected', 'selected');

      select?.addEventListener('change', (evt) => {
        const element = evt.target as HTMLInputElement;
        const value = element.value;
        selectedCategory = value;
        showSelectedAccordion(selectedCategory);
        // sync with desktop
        switchCategory(selectedCategory);
      });
      // options selected should show the correct value
      // selectOptions?.forEach(option => {
      //   const optionCategory = option.value;
      //   if (optionCategory === selectedCategory) {
      //     option.setAttribute('selected', 'selected');
      //   } else {
      //     option.removeAttribute('selected');
      //   }
      // });
    };

    selectDropdown();
  });
